import {UntilDestroy} from '@ngneat/until-destroy';
import {Component, Inject, OnInit} from '@angular/core';
import {WORKBENCH_VIEW_CONFIG, WorkbenchViewConfig} from '../../../shared/types';
import {ProjectId} from '@webmate-web-core/shared/types/ids';
import {faSyncAlt} from '@fortawesome/pro-solid-svg-icons';
import {BrowserSessionInfo} from '@webmate-web-core/shared/types/browsersession';
import {BrowserSessionService} from '@webmate-web-core/shared/services/browsersession.service';
import {switchMap} from 'rxjs/operators';
import {WorkbenchViewComponent} from '../../../shared/components/viewcontainers/workbench-view.component';
import {Subject} from 'rxjs';
import {WorkbenchLayoutManager} from '../../../shared/services/workbench-layout-manager.service';
import {WorkbenchContextService} from '../../../shared/services/workbench-context.service';


@UntilDestroy()
@Component({
    templateUrl: './expedition-list.component.html',
    styleUrls: ['./expedition-list.component.less']
})
export class ExpeditionListComponent extends WorkbenchViewComponent implements OnInit {

    projectId: ProjectId;

    expeditions: BrowserSessionInfo[] = [];

    wantRefresh$: Subject<void> = new Subject<void>();

    loading = false;

    /** True while the active session is locked by a running analysis — selecting a session is disabled. */
    locked = false;

    constructor(@Inject(WORKBENCH_VIEW_CONFIG) public config: WorkbenchViewConfig<any>,
                private browserSessionService: BrowserSessionService,
                layoutManager:  WorkbenchLayoutManager,
                private readonly workbenchContextService: WorkbenchContextService) {
        super(layoutManager, config);
    }


    ngOnInit() {
        const workbenchContext = this.workbenchContextService.getCurrentWorkbenchContext()!;
        this.projectId = workbenchContext.project;

        this.workbenchContextService.subscribeWorkbenchContext$().subscribe(context => {
            this.locked = !!context.expeditionContext?.activeExpeditionLocked;
        });

        this.wantRefresh$.pipe(
            switchMap(() => {
                this.loading = true;
                return this.browserSessionService.getExpeditionsInProject$(this.projectId, 10).fetch()
            })
        ).subscribe(expeditions => {
            this.expeditions = expeditions.result.filter(expeditionInfo => !!expeditionInfo).map(BrowserSessionInfo.fromBackendObject);
            this.loading = false;
        });
        this.wantRefresh$.next();
    }

    reload() {
        this.wantRefresh$.next();
    }

    makeActive(expedition: BrowserSessionInfo) {
        if (this.locked) {
            return;
        }
        this.workbenchContextService.setContextActiveExpedition(expedition);
    }

    protected readonly faSyncAlt = faSyncAlt;
}
